<template>
  <div>
    <v-card
      :is-loading="isLoading"
      variant="tonal"
      color="surface"
      height="1000"
    >
      <VueFlow
        v-if="!isLoading"
        v-model="elements"
        :min-zoom="0.2"
        fit-view-on-init
      >
        <template #node-custom="props">
          <!-- @vue-skip if step doesn't exist it won't render, which is good. -->
          <SoFlowDiagramNodeStep
            v-if="flowDiagram.getNode(props.id)?.step"
            :step="flowDiagram.getNode(props.id)?.step"
          ></SoFlowDiagramNodeStep>
          <!-- @vue-skip if action doesn't exist it won't render, which is good. -->
          <SoFlowDiagramNodeAction
            v-if="flowDiagram.getNode(props.id)?.action"
            :action="flowDiagram.getNode(props.id)?.action"
          ></SoFlowDiagramNodeAction>
          <!-- @vue-skip if condition doesn't exist it won't render, which is good. -->
          <SoFlowDiagramNodeCondition
            v-if="flowDiagram.getNode(props.id)?.condition"
            :condition="flowDiagram.getNode(props.id)?.condition"
          ></SoFlowDiagramNodeCondition>
        </template>
      </VueFlow>
    </v-card>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { IFlow } from "../model/flow.types"
  import { getEmptyFlow } from "../model/flow"
  import { VueFlow, ElementData } from "@vue-flow/core"
  import "@vue-flow/core/dist/style.css"
  import "@vue-flow/core/dist/theme-default.css"
  import SoFlowDiagramNodeStep from "./SoFlowDiagramNodeStep.vue"
  import SoFlowDiagramNodeAction from "./SoFlowDiagramNodeAction.vue"
  import SoFlowDiagramNodeCondition from "./SoFlowDiagramNodeCondition.vue"
  import { capitalize } from "@/helpers/stringHelpers"
  import { FlowDiagram } from "./flowAsDiagram"

  export default defineComponent({
    components: {
      VueFlow,
      SoFlowDiagramNodeStep,
      SoFlowDiagramNodeAction,
      SoFlowDiagramNodeCondition,
    },
    props: {
      flow: {
        type: Object as PropType<IFlow>,
        required: false,
        default: getEmptyFlow(),
      },
    },

    data() {
      return {
        isLoading: true,
        elements: [] as ElementData[],
        flowDiagram: new FlowDiagram(this.flow),
        capitalize,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      async init() {
        const nodes = await this.flowDiagram.getNodes()
        const edges = this.flowDiagram.getEdges()

        this.elements = []
        for (const node of nodes) {
          this.elements.push({
            id: node.id,
            position: { x: node.x, y: node.y },
            type: "custom",
          })
        }
        for (const edge of edges) {
          this.elements.push({
            id: edge.id,
            source: edge.source.id,
            sourceHandle: edge.isHappy ? "happy" : "unhappy",
            target: edge.target.id,
            animated: true,
          })
        }
        this.isLoading = false
      },
    },
  })
</script>
